import { cva } from "../../lib";

export const dropdownContentVariants = cva(
  [
    "web:overflow-hidden rounded-radius-lg p-spacing-xs z-50",
    "bg-luce-neutral-background-default",
    "border-luce-neutral-border-lowEmphasis border",
    "shadow-dropdown",
    "web:animate-in web:fade-in-0 web:zoom-in-95",
    "web:data-[side=bottom]:slide-in-from-top-2 web:data-[side=top]:slide-in-from-bottom-2",
    "web:data-[side=left]:slide-in-from-right-2 web:data-[side=right]:slide-in-from-left-2",
  ].join(" "),
);

export const dropdownItemVariants = cva(
  [
    // Figma: a 12 (padding-md) icon → label gap and an 8 (radius md) corner
    "gap-spacing-md relative flex flex-row items-center",
    "rounded-radius-md px-spacing-lg py-spacing-sm w-full",
    // 44px rows on touch screens and native, not invisible hit areas: adjacent
    // 32px items can't share an overlapping tap area (split rows 144 and 152)
    "native:min-h-touch-target [@media(pointer:coarse)]:min-h-touch-target",
    "transition-colors",
    // Web-only interactions — NativeWind strips `web:` classes on native.
    "web:select-none web:cursor-pointer web:outline-none",
    "web:focus:bg-luce-neutral-background-intermediate",
  ].join(" "),
  {
    variants: {
      disabled: {
        // The label is already attenuated (`getItemColor`); no second fade
        true: "web:cursor-not-allowed pointer-events-none",
        false:
          "web:hover:bg-luce-neutral-background-intermediate active:bg-luce-neutral-background-attenuated web:active:bg-luce-neutral-background-attenuated",
      },
      variant: {
        default: "",
        destructive: "text-luce-system-danger-default",
      },
    },
    defaultVariants: {
      disabled: false,
      variant: "default",
    },
  },
);

// The 1px line (`h-px`) has no token: Figma doesn't draw the separator (split
// row 151)
export const dropdownSeparatorClass = "bg-luce-neutral-border-lowEmphasis my-spacing-xs h-px";
